import type { SupportTicketId } from "@redotech/effect-api-shared/ids/definitions";
import type { ChannelThread } from "@redotech/effect-api-shared/models/shopper-ai/conversation/thread";
import { memo } from "react";
import { ChatThreadView } from "./chat-thread-view";

interface AttentiveThreadViewProps {
  supportTicketId: SupportTicketId;
  thread: ChannelThread;
}

export const AttentiveThreadView = memo(function AttentiveThreadView({
  supportTicketId,
  thread,
}: AttentiveThreadViewProps) {
  return (
    <ChatThreadView
      channel={thread.channel}
      supportTicketId={supportTicketId}
      thread={thread}
    />
  );
});
